var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tour-popup" }, [
    _c(
      "div",
      {
        staticClass: "modal left modal-dashbrd",
        attrs: { id: "modal_dashboard", role: "dialog" },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-md" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c("img", {
                  staticClass: "close-btn",
                  attrs: {
                    src: "/static/images/icons/popup_close.svg",
                    "data-dismiss": "modal",
                    alt: "close-icon",
                  },
                  on: { click: _vm.closePopup },
                }),
                _c("div", { staticClass: "dashboard-heading" }, [
                  _vm.currentTour.image
                    ? _c("span", [
                        _c("img", {
                          staticClass: "tour-icon",
                          attrs: {
                            src: _vm.currentTour.image,
                            alt: "tour-icon",
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" " + _vm._s(_vm.currentTour.type) + " "),
                ]),
                _c("img", {
                  staticClass: "header-swoop",
                  attrs: {
                    src: "https://ramsdevstorage.blob.core.windows.net/customererrorpage/Header_swoop.png",
                    alt: "header-icon",
                  },
                }),
              ]),
              _c("div", [
                _c("p", {
                  staticClass: "dashbrd-txt tour-title-text",
                  domProps: { innerHTML: _vm._s(_vm.currentTour.title) },
                }),
              ]),
              _c("div", {
                staticClass: "list-item pr-15",
                domProps: { innerHTML: _vm._s(_vm.currentTour.content) },
              }),
              _c("div", { staticClass: "btn-next-div" }, [
                _c("div", {
                  staticClass: "modal-arrow",
                  style: [
                    {
                      top: `${
                        _vm.currentTour.key == 0
                          ? 10
                          : _vm.currentTour.clickValue
                      }px`,
                      "border-color": `${
                        _vm.currentTour.key > 3
                          ? (_vm.roleId == 3 || _vm.roleId === 6) &&
                            _vm.currentTour.key == 4
                            ? ""
                            : "transparent #fff transparent transparent"
                          : ""
                      }`,
                    },
                    { top: _vm.clickValue },
                  ],
                }),
                _c(
                  "button",
                  {
                    staticClass: "btn custom-btn mr-16 emergo-white-button",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.previousTour()
                      },
                    },
                  },
                  [_vm._v(" Back ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn custom-btn emergo-green-button",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.playNextTour()
                      },
                    },
                  },
                  [_vm._v(" Next ")]
                ),
              ]),
              _c(
                "div",
                { staticClass: "row" },
                [
                  _vm._l(_vm.tourObjectLength, function (index) {
                    return _c("span", {
                      key: index,
                      class:
                        _vm.tourIndex === index - 1
                          ? "active-round-button"
                          : "round-button",
                    })
                  }),
                  _c("span", { staticClass: "round-button" }),
                ],
                2
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }